'use strict';

import './weather.directive.css';

class WeatherDirective {
  constructor() {
    'ngInject';

    this.restrict = 'E';
    this.scope = {
      weather: '=',
      simple: '=',
      iconSize: '=',
      linkId: '=',
      device: '='
    };
    this.template = require('./weather.directive.html');
  }

  link(scope) {
    scope.iconWidth = 26;
    if(scope.iconSize === 'middle') {
      scope.iconWidth = 25;
    } else if (scope.iconSize === 'small') {
      scope.iconWidth = 15;
    }
  }
}

export default angular.module('leptonApp.weatherDirective', [])
  .directive('weatherDirective', [() => new WeatherDirective()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/weather/weather.directive.js